import { AbstractControl, ValidationErrors } from '@angular/forms';
import { environment } from 'environments/environment.development';

export class ApplicationConstants {
  public static readonly ADMIN_ROLE = 'ADMIN';
  public static readonly RESELLER_ROLE = 'RESELLER';
  public static readonly PRINTER_ROLE = 'PRINTER';
  public static readonly ORGANIZATION_USER_ROLE = 'ORGANIZATIONUSER';

  public static readonly ALLOWED_ROLES = [
    this.ADMIN_ROLE, this.RESELLER_ROLE, this.PRINTER_ROLE, this.ORGANIZATION_USER_ROLE
  ]
}


export class Constants {
  public MAX_SEARCH_LENGTH = 3;
  public static MAX_PAGE_SIZE = 100;
  public static PAGE_SIZE = [5, 10, 20, 100];
  public static PRODUCT_REQUEST_ENABLE_LOOKUP = ["true", "false"];
}

export function excelFileValidator(
  control: AbstractControl
): ValidationErrors | null {
  const file: File = control.value;

  if (file) {
    const validMimeTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
    ];
    const validExtensions = ['.xls', '.xlsx'];

    const isValidMimeType = validMimeTypes.includes(file.type);
    const isValidExtension = validExtensions.some((ext) =>
      file.name.endsWith(ext)
    );

    if (!isValidMimeType || !isValidExtension) {
      return { invalidExcelFile: true };
    }
  }

  return null;
}

export function previewImgFn(fileName: string) {
  if (fileName) {
    if (fileName.includes('blob')) {
      return fileName;
    }
    var base = 'https://fleetblobcz.blob.core.windows.net/fmp/';
    if (fileName.includes(base)) {
      fileName = fileName.split(base)[1];
    }
    return environment.baseUrl + 'api/files/' + encodeURIComponent(fileName);
  }
  return '';
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const ACTION_LIST = {
  ALL: 'all',
  CREATE: 'create',
  DELETE: 'delete',
  EDIT: 'edit',
  EXPORT: 'export',
  PRINT: 'print',
  READONLY: 'readonly',
};

export const USER_ROLES_LIST = {
  ADMIN_ROLE_CREATE: ApplicationConstants.ADMIN_ROLE + '-' + ACTION_LIST.CREATE,
  ADMIN_ROLE_DELETE: ApplicationConstants.ADMIN_ROLE + '-' + ACTION_LIST.DELETE,
  ADMIN_ROLE_EDIT: ApplicationConstants.ADMIN_ROLE + '-' + ACTION_LIST.EDIT,
  ADMIN_ROLE_EXPORT: ApplicationConstants.ADMIN_ROLE + '-' + ACTION_LIST.EXPORT,
  ADMIN_ROLE_PRINT: ApplicationConstants.ADMIN_ROLE + '-' + ACTION_LIST.PRINT,
  ADMIN_ROLE_READONLY:
    ApplicationConstants.ADMIN_ROLE + '-' + ACTION_LIST.READONLY,

  PRINTER_ROLE_CREATE:
    ApplicationConstants.PRINTER_ROLE + '-' + ACTION_LIST.CREATE,
  PRINTER_ROLE_EDIT: ApplicationConstants.PRINTER_ROLE + '-' + ACTION_LIST.EDIT,
  PRINTER_ROLE_DELETE:
    ApplicationConstants.PRINTER_ROLE + '-' + ACTION_LIST.DELETE,
  PRINTER_ROLE_EXPORT:
    ApplicationConstants.PRINTER_ROLE + '-' + ACTION_LIST.EXPORT,
  PRINTER_ROLE_PRINT:
    ApplicationConstants.PRINTER_ROLE + '-' + ACTION_LIST.PRINT,
  PRINTER_ROLE_READONLY:
    ApplicationConstants.PRINTER_ROLE + '-' + ACTION_LIST.READONLY,

  RESELLER_ROLE_CREATE:
    ApplicationConstants.RESELLER_ROLE + '-' + ACTION_LIST.CREATE,
  RESLLER_ROLE_EDIT:
    ApplicationConstants.RESELLER_ROLE + '-' + ACTION_LIST.EDIT,
  RESLLER_ROLE_DELETE:
    ApplicationConstants.RESELLER_ROLE + '-' + ACTION_LIST.DELETE,
  RESELLER_ROLE_EXPORT:
    ApplicationConstants.RESELLER_ROLE + '-' + ACTION_LIST.EXPORT,
  RESELLER_ROLE_PRINT:
    ApplicationConstants.RESELLER_ROLE + '-' + ACTION_LIST.PRINT,
  RESELLER_ROLE_READONLY:
    ApplicationConstants.RESELLER_ROLE + '-' + ACTION_LIST.READONLY,

  ORGANIZATION_USER_ROLE_CREATE:
    ApplicationConstants.ORGANIZATION_USER_ROLE + '-' + ACTION_LIST.CREATE,
  ORGANIZATION_USER_ROLE_EDIT:
    ApplicationConstants.ORGANIZATION_USER_ROLE + '-' + ACTION_LIST.EDIT,
  ORGANIZATION_USER_ROLE_DELETE:
    ApplicationConstants.ORGANIZATION_USER_ROLE + '-' + ACTION_LIST.DELETE,
  ORGANIZATION_USER_ROLE_EXPORT:
    ApplicationConstants.ORGANIZATION_USER_ROLE + '-' + ACTION_LIST.EXPORT,
  ORGANIZATION_USER_ROLE_PRINT:
    ApplicationConstants.ORGANIZATION_USER_ROLE + '-' + ACTION_LIST.PRINT,
  ORGANIZATION_USER_ROLE_READONLY:
    ApplicationConstants.ORGANIZATION_USER_ROLE + '-' + ACTION_LIST.READONLY,
};

export const MAIN_ROLES_LIST = {
  DASHBOARD: 'dashboard',
  ORGANIZATIONS: 'organizations',
  ORDERS: 'orders',
  PENDING_CARDHOLDERS: 'pending-cardholders',
  PRODUCTS: 'products',
  PRODUCT_FORM_TEMPLATES: 'product-form-templates',
  USER_LIST: 'users',
  USER_ROLES: 'user-roles',
  CONFIGURATIONS: 'configurations',
  USER_CARDS: 'user-cards',
};

export const ROLES_LIST = {
  DASHBOARD_CREATE: MAIN_ROLES_LIST.DASHBOARD + '-' + ACTION_LIST.CREATE,
  DASHBOARD_EDIT: MAIN_ROLES_LIST.DASHBOARD + '-' + ACTION_LIST.EDIT,
  DASHBOARD_EXPORT: MAIN_ROLES_LIST.DASHBOARD + '-' + ACTION_LIST.EXPORT,
  DASHBOARD_PRINT: MAIN_ROLES_LIST.DASHBOARD + '-' + ACTION_LIST.PRINT,
  DASHBOARD_READONLY: MAIN_ROLES_LIST.DASHBOARD + '-' + ACTION_LIST.READONLY,
  DASHBOARD_DELETE: MAIN_ROLES_LIST.DASHBOARD + '-' + ACTION_LIST.DELETE,

  ORGANIZATION_CREATE: MAIN_ROLES_LIST.ORGANIZATIONS + '-' + ACTION_LIST.CREATE,
  ORGANIZATION_EDIT: MAIN_ROLES_LIST.ORGANIZATIONS + '-' + ACTION_LIST.EDIT,
  ORGANIZATION_EXPORT: MAIN_ROLES_LIST.ORGANIZATIONS + '-' + ACTION_LIST.EXPORT,
  ORGANIZATION_PRINT: MAIN_ROLES_LIST.ORGANIZATIONS + '-' + ACTION_LIST.PRINT,
  ORGANIZATION_READONLY:
    MAIN_ROLES_LIST.ORGANIZATIONS + '-' + ACTION_LIST.READONLY,
  ORGANIZATION_DELETE: MAIN_ROLES_LIST.ORGANIZATIONS + '-' + ACTION_LIST.DELETE,

  ORDERS_CREATE: MAIN_ROLES_LIST.ORDERS + '-' + ACTION_LIST.CREATE,
  ORDERS_EDIT: MAIN_ROLES_LIST.ORDERS + '-' + ACTION_LIST.EDIT,
  ORDERS_EXPORT: MAIN_ROLES_LIST.ORDERS + '-' + ACTION_LIST.EXPORT,
  ORDERS_PRINT: MAIN_ROLES_LIST.ORDERS + '-' + ACTION_LIST.PRINT,
  ORDERS_READONLY: MAIN_ROLES_LIST.ORDERS + '-' + ACTION_LIST.READONLY,
  ORDERS_DELETE: MAIN_ROLES_LIST.ORDERS + '-' + ACTION_LIST.DELETE,

  PENDING_CARDHOLDERS_CREATE:
    MAIN_ROLES_LIST.PENDING_CARDHOLDERS + '-' + ACTION_LIST.CREATE,
  PENDING_CARDHOLDERS_EDIT:
    MAIN_ROLES_LIST.PENDING_CARDHOLDERS + '-' + ACTION_LIST.EDIT,
  PENDING_CARDHOLDERS_EXPORT:
    MAIN_ROLES_LIST.PENDING_CARDHOLDERS + '-' + ACTION_LIST.EXPORT,
  PENDING_CARDHOLDERS_PRINT:
    MAIN_ROLES_LIST.PENDING_CARDHOLDERS + '-' + ACTION_LIST.PRINT,
  PENDING_CARDHOLDERS_READONLY:
    MAIN_ROLES_LIST.PENDING_CARDHOLDERS + '-' + ACTION_LIST.READONLY,
  PENDING_CARDHOLDERS_DELETE:
    MAIN_ROLES_LIST.PENDING_CARDHOLDERS + '-' + ACTION_LIST.DELETE,

  PRODUCTS_CREATE: MAIN_ROLES_LIST.PRODUCTS + '-' + ACTION_LIST.CREATE,
  PRODUCTS_EDIT: MAIN_ROLES_LIST.PRODUCTS + '-' + ACTION_LIST.EDIT,
  PRODUCTS_EXPORT: MAIN_ROLES_LIST.PRODUCTS + '-' + ACTION_LIST.EXPORT,
  PRODUCTS_PRINT: MAIN_ROLES_LIST.PRODUCTS + '-' + ACTION_LIST.PRINT,
  PRODUCTS_READONLY: MAIN_ROLES_LIST.PRODUCTS + '-' + ACTION_LIST.READONLY,
  PRODUCTS_DELETE: MAIN_ROLES_LIST.PRODUCTS + '-' + ACTION_LIST.DELETE,

  PRODUCT_FORM_TEMPLATES_CREATE:
    MAIN_ROLES_LIST.PRODUCT_FORM_TEMPLATES + '-' + ACTION_LIST.CREATE,
  PRODUCT_FORM_TEMPLATES_EDIT:
    MAIN_ROLES_LIST.PRODUCT_FORM_TEMPLATES + '-' + ACTION_LIST.EDIT,
  PRODUCT_FORM_TEMPLATES_EXPORT:
    MAIN_ROLES_LIST.PRODUCT_FORM_TEMPLATES + '-' + ACTION_LIST.EXPORT,
  PRODUCT_FORM_TEMPLATES_PRINT:
    MAIN_ROLES_LIST.PRODUCT_FORM_TEMPLATES + '-' + ACTION_LIST.PRINT,
  PRODUCT_FORM_TEMPLATES_READONLY:
    MAIN_ROLES_LIST.PRODUCT_FORM_TEMPLATES + '-' + ACTION_LIST.READONLY,
  PRODUCT_FORM_TEMPLATES_DELETE:
    MAIN_ROLES_LIST.PRODUCT_FORM_TEMPLATES + '-' + ACTION_LIST.DELETE,

  USER_LIST_CREATE: MAIN_ROLES_LIST.USER_LIST + '-' + ACTION_LIST.CREATE,
  USER_LIST_EDIT: MAIN_ROLES_LIST.USER_LIST + '-' + ACTION_LIST.EDIT,
  USER_LIST_EXPORT: MAIN_ROLES_LIST.USER_LIST + '-' + ACTION_LIST.EXPORT,
  USER_LIST_PRINT: MAIN_ROLES_LIST.USER_LIST + '-' + ACTION_LIST.PRINT,
  USER_LIST_READONLY: MAIN_ROLES_LIST.USER_LIST + '-' + ACTION_LIST.READONLY,
  USER_LIST_DELETE: MAIN_ROLES_LIST.USER_LIST + '-' + ACTION_LIST.DELETE,

  USER_ROLES_CREATE: MAIN_ROLES_LIST.USER_ROLES + '-' + ACTION_LIST.CREATE,
  USER_ROLES_EDIT: MAIN_ROLES_LIST.USER_ROLES + '-' + ACTION_LIST.EDIT,
  USER_ROLES_EXPORT: MAIN_ROLES_LIST.USER_ROLES + '-' + ACTION_LIST.EXPORT,
  USER_ROLES_PRINT: MAIN_ROLES_LIST.USER_ROLES + '-' + ACTION_LIST.PRINT,
  USER_ROLES_READONLY: MAIN_ROLES_LIST.USER_ROLES + '-' + ACTION_LIST.READONLY,
  USER_ROLES_DELETE: MAIN_ROLES_LIST.USER_ROLES + '-' + ACTION_LIST.DELETE,

  CONFIGURATIONS_CREATE:
    MAIN_ROLES_LIST.CONFIGURATIONS + '-' + ACTION_LIST.CREATE,
  CONFIGURATIONS_EDIT: MAIN_ROLES_LIST.CONFIGURATIONS + '-' + ACTION_LIST.EDIT,
  CONFIGURATIONS_EXPORT:
    MAIN_ROLES_LIST.CONFIGURATIONS + '-' + ACTION_LIST.EXPORT,
  CONFIGURATIONS_PRINT:
    MAIN_ROLES_LIST.CONFIGURATIONS + '-' + ACTION_LIST.PRINT,
  CONFIGURATIONS_READONLY:
    MAIN_ROLES_LIST.CONFIGURATIONS + '-' + ACTION_LIST.READONLY,
  CONFIGURATIONS_DELETE:
    MAIN_ROLES_LIST.CONFIGURATIONS + '-' + ACTION_LIST.DELETE,

  USER_CARDS_CREATE: MAIN_ROLES_LIST.USER_CARDS + '-' + ACTION_LIST.CREATE,
  USER_CARDS_EDIT: MAIN_ROLES_LIST.USER_CARDS + '-' + ACTION_LIST.EDIT,
  USER_CARDS_EXPORT: MAIN_ROLES_LIST.USER_CARDS + '-' + ACTION_LIST.EXPORT,
  USER_CARDS_PRINT: MAIN_ROLES_LIST.USER_CARDS + '-' + ACTION_LIST.PRINT,
  USER_CARDS_READONLY: MAIN_ROLES_LIST.USER_CARDS + '-' + ACTION_LIST.READONLY,
  USER_CARDS_DELETE: MAIN_ROLES_LIST.USER_CARDS + '-' + ACTION_LIST.DELETE,
};
